import Bar from './Models/Bar'

Vue.prototype.$models.$bar = new Vue(Bar)

Vue.component('bars-table', () => import(/* webpackChunkName: "bars-table" */ '@modulesPages/Bar/Resources/assets/js/Tables/BarsTable'))

Vue.component('bars-form', () => import(/* webpackChunkName: "bars-form" */ '@modulesPages/Bar/Resources/assets/js/Forms/Bars/BarsForm'))
Vue.component('default-bars-form', () => import(/* webpackChunkName: "default-bars-form" */ '@modulesPages/Bar/Resources/assets/js/Forms/Bars/DefaultBarsForm'))
Vue.component('number-bars-form', () => import(/* webpackChunkName: "number-bars-form" */ '@modulesPages/Bar/Resources/assets/js/Forms/Bars/NumberBarsForm'))
Vue.component('string-bars-form', () => import(/* webpackChunkName: "string-bars-form" */ '@modulesPages/Bar/Resources/assets/js/Forms/Bars/StringBarsForm'))
Vue.component('textarea-bars-form', () => import(/* webpackChunkName: "textarea-bars-form" */ '@modulesPages/Bar/Resources/assets/js/Forms/Bars/TextareaBarsForm'))

Vue.component('image-bars-form', () => import(/* webpackChunkName: "image-bars-form" */ '@modulesPages/Bar/Resources/assets/js/Forms/Bars/ImageBarsForm'))


app.$Util.formattedClassName = {
	...app.$Util.formattedClassName,
	...{
		'Modules\\Bar\\Entities\\Bar': 'Variable del Sistena',
	}	
}

app.$Util.tableNameByClassName = {
	...app.$Util.tableNameByClassName,
	...{
		'Modules\\Bar\\Entities\\Bar': 'bars',
	}	
}

app.$Util.classNameByTableName = {
	...app.$Util.classNameByTableName,
	...{
		'bars': 'Modules\\Bar\\Entities\\Bar',
	}	
}